import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import { useReportViewEvent, useResponsive } from '../../hooks'
import { updateExtendedBuyerLead } from '../../store/lead/leadSlice'
import { reportTrackingEvent } from '../../tracking/thunks'
import Consultation from '../../components/Consultation/Consultation'
import { BuyerLeadsValuePropositionIcon } from '../../components/icons/StepIcons/BuyerLeadsValuePropositionIcon'
import '../../components/Consultation/Consultation.scss'

interface BuyerLeadsValuePropositionProps {
  goToNextStep: () => unknown
  goToPreviousStep: () => unknown
  displayBack: boolean
}

export const BuyerLeadsValuePropositionStep: FC<BuyerLeadsValuePropositionProps> = (props) => {
  useReportViewEvent({ pageTitle: 'buy' })
  const { isMobile } = useResponsive()
  const dispatch = useDispatch()

  const goToNextStep = (extendedBuyerLead: boolean) => {
    dispatch(updateExtendedBuyerLead(extendedBuyerLead ?? false))
    const inputValue: string = extendedBuyerLead ? 'buy_extended' : 'buy'
    dispatch(
      reportTrackingEvent({
        label: 'rle-buy_submit',
        action: 'realtor-leadengine',
        category: 'residential',
        pageTitle: 'buy',
        inputValue: inputValue,
        eventName: 'lead_input',
        customDimensions: {
          ga_cd_lead_engine_input_value: inputValue,
        },
      })
    )
    props.goToNextStep()
  }
  const headline = (
    <div>Wir helfen dir, deine Traumimmobilie zu finden – {!isMobile && <br />} mit Blick auf deine Finanzen.</div>
  )

  return (
    <Consultation
      goToNextStep={(extendedBuyerLead) => goToNextStep(extendedBuyerLead ?? false)}
      displayBack={true}
      headline={headline}
      textString={'Jetzt kostenlos loslegen'}
      goToPreviousStep={props.goToPreviousStep}
      icon={<BuyerLeadsValuePropositionIcon />}
      className={'buyer-leads-value-proposition-step'}
    />
  )
}

export default BuyerLeadsValuePropositionStep
